<template>
  <div class="mb-1">
    <h4 class="text-left">{{ texts.title }}</h4>
    <p class="avenir-medium" v-if="texts.description">{{ texts.description }}</p>
    <p class="avenir-medium text-muted" v-else>{{ is_avaible_to_editing ? $t('creator.selectDealEditing') : $t('creator.selectDeal') }}</p>
    <b-row class="m-0">
      <b-col :class="`${is_avaible_to_editing ? 'col-12 col-lg-8' : 'col-12'} p-0`">

        <!-- Skeleton state -->
        <template v-if="loading">
          <div
            v-for="i in skeleton_count"
            :key="i"
            class="deal-skeleton-card"
            :class="{ 'mb-1': i < skeleton_count }"
          >
            <div class="d-flex justify-content-between align-items-start mb-1">
              <b-skeleton width="55%" height="16px"></b-skeleton>
              <div class="d-flex align-items-center">
                <b-skeleton width="80px" height="14px" class="mr-1"></b-skeleton>
                <b-skeleton type="avatar" size="18px"></b-skeleton>
              </div>
            </div>
            <div class="d-flex flex-wrap mb-1">
              <b-skeleton width="110px" height="12px" class="mr-2"></b-skeleton>
              <b-skeleton width="90px" height="12px" class="mr-2"></b-skeleton>
              <b-skeleton width="120px" height="12px"></b-skeleton>
            </div>
            <b-skeleton width="100%" height="12px" class="mb-05"></b-skeleton>
            <b-skeleton width="85%" height="12px" class="mb-05"></b-skeleton>
            <b-skeleton width="60%" height="12px" class="mb-1"></b-skeleton>
            <hr class="mb-1"/>
            <b-skeleton width="100px" height="12px" class="mb-1"></b-skeleton>
            <div class="d-flex flex-wrap">
              <b-skeleton width="72px" height="24px" class="mr-1 mb-1" style="border-radius: 0.5em"></b-skeleton>
              <b-skeleton width="88px" height="24px" class="mr-1 mb-1" style="border-radius: 0.5em"></b-skeleton>
              <b-skeleton width="64px" height="24px" class="mr-1 mb-1" style="border-radius: 0.5em"></b-skeleton>
            </div>
          </div>
        </template>

        <b-form-radio-group v-else-if="proposals && proposals.length > 0" @input="$emit('update:selected_deal_radio', $event)" class="w-100" v-model="selected_deal_radio">
          <deal-radio
            v-for="(deal, index) in proposals"
            :key="index"
            :index="index"
            :deal="deal"
            :is-last="index + 1 === proposals.length"
            :is_avaible_to_editing="is_avaible_to_editing"
            :is_in_sidebar_chat="is_in_sidebar"
            :loaded_ia="false"
            :selected="selected_deal_radio"
            :value="selected_deal_radio"
            :chat_uuid="chat_uuid"
            :is_brandme_talent="deal.is_brandme_talent"
            @deal_selected="$emit('deal_selected', $event)"
            @edit_deal="editDeal"
            @delete_deal="$emit('delete_deal', $event)"
          />
        </b-form-radio-group>

        <div v-else class="empty-state-deals text-center">
          <b-img :src="require('@/assets/images/no_results.svg')" class="mb-2" style="max-width: 120px;" />
          <h5 class="avenir-bold">{{ $t('creator.noDeals') }}</h5>
          <p class="avenir-medium text-muted">{{ $t('creator.noDealsDesc') }}</p>
        </div>

        <b-button v-if="!loading && (is_avaible_to_editing) && !is_in_sidebar" class="add-deal-action mt-2" variant="add-deal-action" @click="$emit('edit_deal', 'deals')">
          <span class="avenir-bold">{{ $t('creator.addDeal') }}</span>
        </b-button>
    
        <pagination-brandme-v2
          v-if="!loading && total_rows"
          :current_page="current_page"
          :total_rows="total_rows"
          :per_page="per_page"
          @update_current_page="$emit('update_current_page', $event)"
          class="mt-1"
        />
      </b-col>
  
      <b-col class="d-none d-lg-block col-4 p-0 pl-2" v-if="is_avaible_to_editing && !loading">
        <div class="bubble-edit" @click="$emit('edit_deal', 'deals')">
          <feather-icon icon="Edit2Icon"></feather-icon>
          <span class="ml-05 avenir-bold">{{ $t('creator.dealsStep') }}</span>
          <p class="avenir-medium m-0 mt-1">{{ $t('creator.editDealDesc') }}</p>
        </div>        
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BFormRadioGroup, BCol, BRow, BButton, BSkeleton, BImg } from 'bootstrap-vue';

export default {
  name: 'DealsListSection',
  components: {
    BFormRadioGroup,
    BCol,
    BRow,
    BButton,
    BSkeleton,
    BImg,
    dealRadio: () => import('@/views/components/proposals/components/dealRadio.vue'),
    PaginationBrandmeV2: () => import('@/views/components/pagination/paginationBrandmeV2.vue'),
  },
  data() {
    return {
      skeleton_count: 3,
    };
  },
  props: {
    texts: {
      type: Object,
      default: () => ({
        title: 'Paquetes',
        description: '',
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    is_brandme_talent: {
      type: Boolean,
      default: false,
    },
    proposals: {
      type: Array,
      default: () => [],
    },
    selected_deal_radio: {
      type: Object,
      default: () => ({ price: 0, licensing: null }),
    },
    is_avaible_to_editing: {
      type: Boolean,
      default: false,
    },
    is_in_sidebar: {
      type: Boolean,
      default: false,
    },
    current_page: {
      type: Number,
      default: 1,
    },
    total_rows: {
      type: Number,
      default: 0,
    },
    per_page: {
      type: Number,
      default: 5,
    },
    chat_uuid: {
      type: String,
      default: null,
    },
  },
  emits: ['update:selected_deal_radio', 'deal_selected', 'update_current_page'],
  methods: {
    editDeal(section, data) {
      this.$emit('edit_deal', section, data);
    }
  }
};
</script>
<style lang="scss" scoped>
.bubble-edit {
  text-align: left;
  padding: 1em;
  color: #3b8DA8;
  background: #E6f2f6;
  border-radius: 1em;
  cursor: pointer;
  position: sticky  ;
  position: -webkit-sticky;
  top: 12em;
}
.bubble-edit:hover {
  transition: all 300ms;
  background: #3b8da82f;
}
.bubble-edit:before {
  border: 10px solid #E6f2f6;
  content: '';
  border-left-color: transparent;
  border-bottom-color: transparent;
  border-right-color: transparent;
  position: absolute;
  transform: rotate(90deg);
  left: -19px;
}
.bubble-edit:hover:before {
  border: 10px solid #3b8da82f;
  content: '';
  border-left-color: transparent;
  border-bottom-color: transparent;
  border-right-color: transparent;
  position: absolute;
  transform: rotate(90deg);
  left: -19px;
  transition: all 300ms;
}
.add-deal-action {
  width: 100%;
  color: #3b8DA8;
  background-color: #E6f2f6;
  border: 1px solid #3b8DA8;
  padding: 2em;
  border-radius: 1em;
}
.add-deal-action:hover {
  color: #ffff;
  transition: all 500ms;
  background-color: #3b8DA8;
}
.deal-skeleton-card {
  padding: 1em;
  border: 1px solid #e8e8e8;
  border-radius: 1em;
  background: #fff;
}
.mb-05 {
  margin-bottom: 0.3rem;
}
</style>